import { imgLoader } from '@utils/imgLoader';
import OriginalNextImage, { ImageProps } from 'next/legacy/image';
import * as React from 'react';

export const NextImage: React.FC<ImageProps> = ({ loader, ...other }) => {
  // HACK  next/image know nothing about css prop
  return (
    <OriginalNextImage
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      {...(other as any)}
      loader={loader ?? imgLoader}
    />
  );
};

NextImage.displayName = 'NextImage';
